"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WidgetError_1 = require("auto-widget-framework/src/Error/WidgetError");
class TooManyValuationError extends WidgetError_1.default {
    constructor(message) {
        super(message);
        // Explicitly set proto.
        Object.setPrototypeOf(this, TooManyValuationError.prototype);
        this.name = this.getCode();
    }
}
exports.default = TooManyValuationError;
TooManyValuationError.code = "TOO-MANY-VALUATION-ERROR";
